var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"circle circle__high"},[_c('section',{staticClass:"circle circle__mid"},[_c('img',{attrs:{"src":require("./assets/check.svg"),"alt":"check grenn icon"}})])])
}]

export { render, staticRenderFns }